import { render, staticRenderFns } from "./Supplychain.vue?vue&type=template&id=b39bfb20&scoped=true"
import script from "./Supplychain.vue?vue&type=script&lang=js"
export * from "./Supplychain.vue?vue&type=script&lang=js"
import style0 from "./Supplychain.vue?vue&type=style&index=0&id=b39bfb20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39bfb20",
  null
  
)

export default component.exports